"use client";

import { Button, Input, Select, Textarea } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const WiderrufClient = () => {
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [product, setProduct] = useState<string | null>(null);

    const { t } = useTranslation();

    const raw = t("escaperooms", {
        returnObjects: true,
        interpolation: { skipOnVariables: false },
    });

    const escapeRoomsData = Array.isArray(raw) ? raw : [];

    const paidRooms = escapeRoomsData.filter((r) => r.price > 0);

    // Mantine expects { value, label }
    const products = paidRooms.map((r) => ({
        value: r.title,
        label: r.title,
    }));

    const finalProducts = [...products, { value: "bundle", label: "Bundle" }];

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData(e.currentTarget);

        const payload = {
            name: formData.get("name"),
            email: formData.get("email"),
            message: formData.get("message"),
            product,
        };

        try {
            const res = await fetch("/api/widerruf", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (res.ok) {
                setDone(true);
            }
        } finally {
            setLoading(false);
        }
    };

    if (done) {
        return (
            <div className="impress-screen">
                <p>{t("cancellation.finished")}</p>
            </div>
        );
    }

    return (
        <div className="impress-screen">
            <form onSubmit={handleSubmit}>
                <Input.Wrapper label={t("cancellation.name")} required>
                    <Input name="name" placeholder={t("cancellation.name")} />
                </Input.Wrapper>

                <Input.Wrapper label={t("cancellation.email")} required>
                    <Input name="email" placeholder={t("cancellation.emailPlaceholder")} />
                </Input.Wrapper>

                <Select
                    label={t("cancellation.product")}
                    placeholder={t("cancellation.productPlaceholder")}
                    data={finalProducts}
                    value={product}
                    onChange={setProduct}
                    required
                />

                <Textarea name="message" label={t("cancellation.message")} placeholder={t("cancellation.messagePlaceholder")} />

                <Button type="submit" disabled={loading || !product} mt="lg">
                    {loading ? t("cancellation.sending") : t("cancellation.submit")}
                </Button>
            </form>
        </div>
    );
};

export default WiderrufClient;
